// src/context/api.js
export const BASE_URL = 'https://www.oxfordstudycenter.online';
